import { offerPosterModalData } from '@spo/logic';
import { SpoProductNaturesResponse } from '@spo/types';
import { useQuery } from '@tanstack/react-query';
import { sleep } from '../utils/sleep';
import { useProductNatures } from './useProductNatures';

export const useNatureOfferPosterModal = (
  sportSelected: number | null,
  searchNatureInput: string,
  debounce = false,
) => {
  const { data: searchedNaturesData } = useProductNatures(
    sportSelected ? [sportSelected] : [],
    searchNatureInput,
  );

  return useQuery({
    queryKey: ['useNatureOfferPosterModal', sportSelected, searchedNaturesData],
    queryFn: async ({ signal }) => {
      if (debounce) {
        await sleep(500);
      }
      if (!signal?.aborted) {
        return offerPosterModalData.getDataNature(
          searchedNaturesData as SpoProductNaturesResponse,
        );
      }
    },
    enabled:
      sportSelected !== null &&
      !!searchedNaturesData &&
      searchedNaturesData.length > 0,
  });
};
